import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RestAPIEndpoints } from '@lifeomic/react-client';

type BedrockModel =
  RestAPIEndpoints['GET /v1/agents-v2/models']['Response']['models'][number];

const messages = defineMessages({
  label: {
    id: 'ModelSelect.label',
    defaultMessage: 'Foundation Model',
  },
  default: {
    id: 'ModelSelect.default',
    defaultMessage: 'Default Model',
  },
  helpMessage: {
    id: 'ModelSelect.helpMessage',
    defaultMessage:
      'Haiku models are faster and cheaper but may not be as accurate. Sonnet models are default and the best balance of speed and accuracy. Opus models are the most advanced but are the slowest and most expensive.',
  },
});

type ModelSelectProps = {
  modelId?: string;
  setModelId: (modelId?: string) => void;
  hideLabel?: boolean;
  models: BedrockModel[];
};

export const ModelSelect: React.FC<ModelSelectProps> = ({
  modelId,
  setModelId,
  models,
  hideLabel = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Select
      label={hideLabel ? '' : formatMessage(messages.label)}
      aria-label={hideLabel ? formatMessage(messages.label) : undefined}
      value={modelId ?? ''}
      onChange={value => setModelId(value || undefined)}
      fullWidth
      helpMessage={formatMessage(messages.helpMessage)}
    >
      <SelectOption value="" title={formatMessage(messages.default)} />
      {models.map(model => (
        <SelectOption
          key={model.model_id}
          value={model.model_id}
          title={model.model_label}
        />
      ))}
    </Select>
  );
};
